import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getPAGAA000, getPAHAE010UpdateView, postPAHAE010 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import { updateMenuVisibility } from '../../../utils';

const PAHAE010 = () => {
    const [pages, setPages] = useState({});
    const [dataFAQs, setDataFAQs] = useState({});
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [activeIndex, setActiveIndex] = useState(null);
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);

    const handleFAQsShow = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        postPAHAE010({
            page,
        })
            .then(({ data }) => {
                setPages(data.info);
                setDataFAQs(data.data);
            })
            .catch((error) => console.log(error));
    }, [page]);

    return (
        <div id="content">
            <Nav menu={customerServiceMenu} />
            {/* Start Accordion */}
            <div id="accordion">
                <div className="container">
                    <div className="titleText">자주 묻는 질문</div>
                    <div className="content-frame">
                        <ul className="accordion-list">
                            {dataFAQs && dataFAQs.length > 0 ? (
                                dataFAQs.map((item, index) => {
                                    const isActive = activeIndex === index;
                                    return (
                                        <li
                                            className={`accodion-item ${isActive ? 'active' : ''}`}
                                            key={`faqs-${index}`}
                                        >
                                            <div
                                                className={`accordion-question view-more-btn ${
                                                    isActive ? 'active' : ''
                                                }`}
                                                onClick={() => {
                                                    !isActive &&
                                                        getPAHAE010UpdateView(item.seq)
                                                            .then()
                                                            .catch((error) => console.log(error));
                                                    handleFAQsShow(index);
                                                }}
                                            >
                                                <span className="accordion-feature">Q</span>
                                                <span className="question-text">{item?.title}</span>
                                                <i className="arrow-icon" />
                                            </div>
                                            <div
                                                className={`accordion-ans content-terms ${isActive ? 'active' : ''}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: item?.contentFile
                                                        ? `<div class="flex-center"><div class="accordion-feature red">A</div><div  class="answer-text">${decodeHTML(
                                                              item?.contentFile,
                                                          )}</div></div>`
                                                        : 'No content available',
                                                }}
                                            ></div>
                                        </li>
                                    );
                                })
                            ) : (
                                <li className="no-data">데이터없습니다</li>
                            )}
                        </ul>

                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
            {/* End Accordion */}
        </div>
    );
};

export default PAHAE010;
